export function getCompanyDashboardPath(tab = "home", hash = "") {
	const suffix = hash ? `#${hash.replace(/^#/, "")}` : "";
	return `/company/dashboard/${tab}${suffix}`;
}

export function getCompanySetupPath() {
	return "/company/setup";
}

export function getCompanyUpgradePath() {
	return "/company/upgrade";
}

export function getCompanyPublicPath(companyId) {
	return `/companies/${companyId}`;
}

export function getCompanyVerifiedPath(companyId, options = {}) {
	const search = options.preview === "dashboard" ? "?preview=dashboard" : "";
	return `/companies/${companyId}/verified${search}`;
}
